export const formatDefaultFolderName = name => {
  if (name === "default") {
    return "Unbenannte Liste";
  }
  return name;
};
